import './indicator-list.component.ajscss';

import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import { IWallboardService } from '@wallboard/wallboard.service';
import { copy, IComponentController, IComponentOptions, IFormController, isDefined, isObject } from 'angular';
import { i18n } from 'i18next';

import { ChannelUtil, DisplayDeprecatedComponent, ToastClass, ToastType } from '@contact/upgrade';

import templateUrl from './indicator-list.component.ajs.html';

class IndicatorListCtrl extends DisplayDeprecatedComponent implements IComponentController {
  // Table
  private rows: any[] = [];
  public columns = [
    { name: 'name', sortName: 'name.keyword', style: { width: '30%' } },
    { name: 'description', sortName: null, style: { width: '60%' } },
  ];
  // Sort
  private sortKey = '';
  private reverse = false;
  // Pagination
  public totalItems = 0;
  private itemsPerPage = 10;
  public maxSize = 3; // Number of pager buttons to show
  private currentPage = 1;
  // Modal
  private createMode = true;
  public newIndicatorState = false;
  public confirmDeleteState = false;
  private indicatorIdToDelete = null;
  private indicatorIndexTodelete: any = null;
  private newIndicator: any = {
    name: '',
    description: '',
    properties: [],
  };
  private currentFamily = '';
  private currentTargetType = '';
  private currentTarget: any = '';
  private currentIndicator: any = '';
  private currentNumericValue = 0;
  public familyList;
  public targetTypeList = [];
  private targetList: any[] = [];
  public indicatorList = [];
  private teamIndicatorList;
  private groupIndicatorList;
  private contactSkillIndicatorList;
  private contactSkillQueueIndicatorList;
  private campaignIndicatorList;
  private flowIndicatorList;
  private goalsSkillIndicatorList;
  private contactFlowIndicatorList;
  private counterIndicatorList;
  private serviceIndicatorList;
  private csrTargetTypeList;
  private contactTargetTypeList;
  private goalsTargetTypeList;
  private countersTargetTypeList;
  private availableTeams = [];
  private availableGroups = [];
  private availableSkills: any[] = [];
  private availableMissions = [];
  private availableFlows: any[] = [];
  private availableCampaigns = [];
  private availableCounters = [];
  private availableServices = [];
  private availableChannels: any[] = [];
  private contactMailSkillIndicatorList = [];
  private contactMailFlowIndicatorList = [];
  private goalsMailChannelIndicatorList = [];
  private contactSkillIndicatorListWithPhone = [];
  private goalsSkillIndicatorListWithPhone = [];
  private indicatorForm: IFormController;

  constructor(
    private readonly $i18next: i18n,
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private readonly wallboardService: IWallboardService
  ) {
    super();
  }

  $onInit() {
    this.familyList = this.wallboardService.familyList();
    this.teamIndicatorList = this.wallboardService.getTeamIndicatorList();
    this.groupIndicatorList = this.wallboardService.groupIndicatorList();
    this.contactSkillIndicatorList = this.wallboardService.contactSkillIndicatorList();
    this.contactSkillQueueIndicatorList = this.wallboardService.contactSkillQueueIndicatorList();
    this.campaignIndicatorList = this.wallboardService.campaignIndicatorList();
    this.flowIndicatorList = this.wallboardService.flowIndicatorList();
    this.goalsSkillIndicatorList = this.wallboardService.goalsSkillIndicatorList();
    this.contactFlowIndicatorList = this.wallboardService.contactFlowIndicatorList();
    this.counterIndicatorList = this.wallboardService.counterIndicatorList();
    this.serviceIndicatorList = this.wallboardService.serviceIndicatorList();
    this.csrTargetTypeList = this.wallboardService.csrTargetTypeList();
    this.contactTargetTypeList = this.wallboardService.contactTargetTypeList();
    this.goalsTargetTypeList = this.wallboardService.goalsTargetTypeList();
    this.countersTargetTypeList = this.wallboardService.countersTargetTypeList();
    this.contactMailSkillIndicatorList = this.wallboardService.contactMailSkillIndicatorList();
    this.contactMailFlowIndicatorList = this.wallboardService.contactMailFlowIndicatorList();
    this.goalsMailChannelIndicatorList = this.wallboardService.goalsMailChannelIndicatorList();
    this.contactSkillIndicatorListWithPhone = this.wallboardService.contactSkillIndicatorListWithPhone();
    this.goalsSkillIndicatorListWithPhone = this.wallboardService.goalsSkillIndicatorListWithPhone();

    this.wallboardService.getTeams().subscribe(response => {
      if (response.status !== 204 && isObject(response.data)) {
        response.data.data.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );
        this.availableTeams = response.data.data;
      }
    });

    this.wallboardService.getGroups().subscribe(response => {
      if (response.status !== 204 && isObject(response.data)) {
        response.data.data.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );
        this.availableGroups = response.data.data;
      }
    });

    this.wallboardService.getSkills().subscribe(response => {
      if (response.status !== 204 && isObject(response.data)) {
        response.data.data.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );
        this.availableSkills = response.data.data;
      }
    });

    this.wallboardService.getMissions().subscribe(response => {
      if (response.status !== 204 && isObject(response.data)) {
        response.data.data.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );
        this.availableMissions = response.data.data;
      }
    });

    this.wallboardService.getCounters().subscribe(response => {
      if (response.status !== 204 && isObject(response.data)) {
        response.data.data.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );
        this.availableCounters = response.data.data;
      }
    });

    this.wallboardService.getServices().subscribe(response => {
      if (response.status !== 204 && isObject(response.data)) {
        response.data.data.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );
        this.availableServices = response.data.data;
      }
    });

    this.wallboardService.getChannels().subscribe(response => {
      if (response.status !== 204 && isObject(response.data)) {
        response.data.data.sort((a, b) =>
          a.type.localeCompare(b.type, undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );
        response.data.data.forEach(channel => {
          if (channel.type === 'MAIL') {
            this.availableChannels.push({
              name: this.$i18next.t('commons:basic.channels.' + ChannelUtil.toString(channel)),
              uuid: ChannelUtil.toString(channel),
            });
          }
        });
      }
    });

    this.wallboardService.getMediaEntryPoints().subscribe(response => {
      if (response.status !== 204 && isObject(response.data)) {
        response.data.data.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );
        this.availableFlows = response.data.data;
        // Retrieve all campaigns and filter on the realStatus
        this.wallboardService.getCampaigns(this.availableFlows).then(success => {
          this.availableCampaigns = success.data.reduce((result, campaign) => {
            if (campaign.realStatus !== 'ENDED' && campaign.realStatus !== 'NOT_STARTED') {
              result.push({
                uuid: campaign.idCampaign,
                name: campaign.name,
              });
            }
            return result;
          }, []);
        });
      }
    });

    // Init indicator list
    this.getIndicatorList();
  }

  public sort(keyName) {
    this.sortKey = keyName;
    this.reverse = !this.reverse;
    this.currentPage = 1;
    this.getIndicatorList();
  }

  onChangeCurrentFamily() {
    if (this.currentFamily === 'CSR') {
      this.targetTypeList = this.csrTargetTypeList;
    } else if (this.currentFamily === 'CONTACT') {
      this.targetTypeList = this.contactTargetTypeList;
    } else if (this.currentFamily === 'GOALS') {
      this.targetTypeList = this.goalsTargetTypeList;
    } else if (this.currentFamily === 'COUNTERS') {
      this.targetTypeList = this.countersTargetTypeList;
    } else {
      this.targetTypeList = [];
    }
    this.currentTargetType = '';
    this.onChangeCurrentTargetType();
  }

  onChangeCurrentTargetType() {
    if (this.currentTargetType === 'TEAM') {
      this.targetList = this.availableTeams;
      this.indicatorList = this.teamIndicatorList;
    } else if (this.currentTargetType === 'GROUP') {
      this.targetList = this.availableGroups;
      this.indicatorList = this.groupIndicatorList;
    } else if (this.currentTargetType === 'SKILL') {
      this.targetList = this.availableSkills;
      if (this.currentFamily === 'CONTACT') {
        this.indicatorList = this.contactSkillIndicatorList;
      } else if (this.currentFamily === 'GOALS') {
        this.indicatorList = this.goalsSkillIndicatorList;
      }
    } else if (this.currentTargetType === 'SKILLS_QUEUE') {
      this.targetList = this.availableSkills.map(skill => ({ uuid: skill.uuid, name: skill.name }));
      if (this.currentFamily === 'CONTACT') {
        this.indicatorList = this.contactSkillQueueIndicatorList;
      }
    } else if (this.currentTargetType === 'MISSION') {
      this.targetList = this.availableMissions;
    } else if (this.currentTargetType === 'FLOW') {
      this.targetList = this.availableFlows;
      if (this.currentFamily === 'CONTACT') {
        const isEmailFlow = this.isEmailFlow();
        if (isEmailFlow) {
          this.indicatorList = this.contactMailFlowIndicatorList;
        } else {
          this.indicatorList = this.contactFlowIndicatorList;
        }
      } else {
        this.indicatorList = this.flowIndicatorList;
      }
    } else if (this.currentTargetType === 'CAMPAIGN') {
      this.targetList = this.availableCampaigns;
      this.indicatorList = this.campaignIndicatorList;
    } else if (this.currentTargetType === 'COUNTER') {
      this.targetList = this.availableCounters;
      this.indicatorList = this.counterIndicatorList;
    } else if (this.currentTargetType === 'SERVICE') {
      this.targetList = this.availableServices;
      this.indicatorList = this.serviceIndicatorList;
    } else if (this.currentTargetType === 'CHANNEL') {
      this.targetList = this.availableChannels;
      this.indicatorList = this.goalsMailChannelIndicatorList;
    } else {
      this.targetList = [];
      this.indicatorList = [];
    }
    this.currentTarget = '';
    if (this.currentTargetType === 'SKILLS_QUEUE') {
      this.currentTarget = [];
    } else {
      this.currentTarget = '';
    }
    this.currentIndicator = '';
    this.onChangeCurrentTarget();
  }

  onChangeCurrentTarget() {
    if (this.currentTargetType === 'SKILL') {
      const isEmailSkill = this.isEmailSkill();
      const skillHasPhoneIncoming = this.skillHasPhoneIncoming();
      if (this.currentFamily === 'GOALS') {
        if (skillHasPhoneIncoming) {
          this.indicatorList = this.goalsSkillIndicatorListWithPhone;
        } else {
          this.indicatorList = this.goalsSkillIndicatorList;
        }
      } else if (this.currentFamily === 'CONTACT') {
        if (isEmailSkill) {
          this.indicatorList = this.contactMailSkillIndicatorList;
        } else if (skillHasPhoneIncoming) {
          this.indicatorList = this.contactSkillIndicatorListWithPhone;
        } else {
          this.indicatorList = this.contactSkillIndicatorList;
        }
      }
    } else if (this.currentFamily === 'CONTACT' && this.currentTargetType === 'SKILLS_QUEUE') {
      this.indicatorList = this.contactSkillQueueIndicatorList;
    } else if (this.currentFamily === 'CONTACT' && this.currentTargetType === 'FLOW') {
      const isEmailFlow = this.isEmailFlow();
      if (isEmailFlow) {
        this.indicatorList = this.contactMailFlowIndicatorList;
      } else {
        this.indicatorList = this.contactFlowIndicatorList;
      }
    }
  }

  isEmailFlow() {
    return this.availableFlows.some(flow => flow.uuid === this.currentTarget && flow.media.mediaType === 'MAIL');
  }

  skillHasPhoneIncoming() {
    return this.availableSkills.some(
      skill =>
        skill.uuid === this.currentTarget &&
        skill.channelConfDtos.some(channelConf => channelConf.mediaType === 'PHONE' && channelConf.mediaDirection === 'INCOMING')
    );
  }

  isEmailSkill() {
    return this.availableSkills.some(
      skill =>
        skill.uuid === this.currentTarget &&
        skill.channelConfDtos.length === 1 &&
        skill.channelConfDtos[0].mediaType === 'MAIL' &&
        skill.channelConfDtos[0].mediaDirection === 'INCOMING'
    );
  }

  pageChanged() {
    this.getIndicatorList();
  }

  getIndicatorList() {
    this.wallboardService
      .execIndicatorRequest(this.itemsPerPage, (this.currentPage - 1) * this.itemsPerPage, this.sortKey, this.reverse ? 'desc' : 'asc')
      .subscribe(
        data => {
          // Success Callback
          this.processSuccessList(data.data);
        },
        () => {
          // Error Callback
          this.processErrorList();
        }
      );
  }

  processSuccessList(data) {
    if (data) {
      this.rows = [];
      for (let i = 0; i < data.hits.hits.length; i++) {
        if (data.hits.hits[i]._source !== null) {
          this.rows.push(data.hits.hits[i]._source);
        }
      }
      this.totalItems = data.hits.total.value;
    } else {
      this.processErrorList();
    }
  }

  processErrorList() {
    this.toastDeprecatedService.alert('wallboard:viewIndicators.toast.getError');
  }

  removeIndicator() {
    this.wallboardService.deleteIndicator(this.indicatorIdToDelete).then(
      data => this.removeProcessed(data),
      () => this.removeErrorOccurred()
    );
  }

  removeProcessed(e) {
    if (e) {
      this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:viewIndicators.toast.deleteSuccess', ToastClass.WALLBOARD, 1500);
      this.rows.splice(this.indicatorIndexTodelete, 1);
      this.closeConfirmDelete();
    } else {
      this.removeErrorOccurred();
    }
  }

  removeErrorOccurred() {
    this.toastDeprecatedService.alert('wallboard:viewIndicators.toast.deleteError');
    this.closeConfirmDelete();
  }

  saveIndicator() {
    let indicator = copy(this.newIndicator);
    indicator.properties = JSON.stringify(indicator.properties);
    if (this.createMode) {
      this.wallboardService.addIndicator(indicator).then(
        data => this.addProcessed(data),
        () => this.addErrorOccurred()
      );
    } else {
      this.wallboardService.updateIndicator(indicator).then(
        data => this.updateProcessed(data),
        () => this.updateErrorOccurred()
      );
    }
  }

  addProcessed(e) {
    if (e.data) {
      this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:viewIndicators.toast.addSuccess', ToastClass.WALLBOARD, 1500);
      this.closeIndicatorCreation();
      setTimeout(() => this.getIndicatorList(), 1500);
    } else {
      this.addErrorOccurred();
    }
  }

  addErrorOccurred() {
    this.toastDeprecatedService.alert('wallboard:viewIndicators.toast.addError');
    this.closeIndicatorCreation();
  }

  updateProcessed(e) {
    if (e.data) {
      this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:viewIndicators.toast.updateSuccess', ToastClass.WALLBOARD, 1500);
      this.closeIndicatorCreation();
      setTimeout(() => this.getIndicatorList(), 1500);
    } else {
      this.updateErrorOccurred();
    }
  }

  updateErrorOccurred() {
    this.toastDeprecatedService.alert('wallboard:viewIndicators.toast.updateError');
    this.closeIndicatorCreation();
  }

  openIndicatorCreation() {
    this.createMode = true;
    this.newIndicatorState = true;
  }

  closeIndicatorCreation() {
    this.newIndicator = {
      name: '',
      description: '',
      properties: [],
    };
    this.currentFamily = '';
    this.currentTargetType = '';
    this.currentTarget = '';
    this.currentIndicator = '';
    this.currentNumericValue = 0;
    this.indicatorForm.$setPristine();
    this.newIndicatorState = false;
  }

  editIndicator(indicator) {
    this.newIndicator = {
      uuid: indicator.uuid,
      name: indicator.name,
      description: indicator.description,
      properties: JSON.parse(indicator.properties),
    };
    this.createMode = false;
    this.newIndicatorState = true;
  }

  openConfirmDelete(indicator, index) {
    this.indicatorIdToDelete = indicator.uuid;
    this.indicatorIndexTodelete = index;
    this.confirmDeleteState = true;
  }

  closeConfirmDelete() {
    this.confirmDeleteState = false;
    this.indicatorIdToDelete = null;
    this.indicatorIndexTodelete = null;
  }

  displayItem(data) {
    if (typeof data !== 'object') {
      return data;
    }
    return data.label;
  }

  propertyType(data) {
    if (typeof data !== 'object') {
      return 'operator';
    }
    return 'indicator';
  }

  removeLastItem() {
    this.newIndicator.properties.pop();
  }

  canAddIndicator() {
    if (
      this.currentFamily !== null &&
      this.currentFamily !== undefined &&
      this.currentFamily === 'NUMERIC' &&
      this.currentNumericValue !== null &&
      this.currentNumericValue !== undefined &&
      isDefined(this.currentNumericValue)
    ) {
      return !isNaN(parseFloat(this.currentNumericValue.toString())) && isFinite(this.currentNumericValue);
    } else {
      return (
        this.currentFamily != null &&
        this.currentTargetType != null &&
        this.currentTarget != null &&
        this.currentIndicator != null &&
        this.currentFamily !== '' &&
        this.currentTargetType !== '' &&
        this.currentTarget !== '' &&
        this.currentIndicator !== ''
      );
    }
  }

  addIndicator() {
    if (typeof this.newIndicator.properties[this.newIndicator.properties.length - 1] === 'object') {
      this.newIndicator.properties.pop();
    }
    let indicator: any = {};
    if (this.currentFamily !== 'NUMERIC') {
      indicator.indicator = JSON.parse(this.currentIndicator).id;
      indicator.target = copy(this.currentTarget);
      let targetName = '';
      if (typeof this.currentTarget === 'string') {
        const target = this.targetList.find(t => t.uuid === this.currentTarget);
        targetName = '(' + target.name + ')';
      } else {
        targetName = '(' + this.currentTarget.map(t => t.name).join(', ') + ')';
      }
      indicator.label = this.$i18next.t(JSON.parse(this.currentIndicator).name) + ' ' + targetName;
    } else {
      indicator.indicator = parseFloat(this.currentNumericValue.toString());
      indicator.label = this.currentNumericValue;
    }
    this.newIndicator.properties.push(indicator);
  }

  addOperator(operator) {
    let length = this.newIndicator.properties.length;
    if (operator === '(') {
      if (
        length !== 0 &&
        (typeof this.newIndicator.properties[length - 1] === 'object' || this.newIndicator.properties[length - 1] === ')')
      ) {
        this.newIndicator.properties.push('*');
      }
      this.newIndicator.properties.push(operator);
    } else if (operator === ')') {
      let fb = 0;
      let lb = 0;
      this.newIndicator.properties.forEach(property => {
        if (property === '(') {
          fb++;
        } else if (property === ')') {
          lb++;
        }
      });
      if (
        length !== 0 &&
        fb - lb > 0 &&
        (typeof this.newIndicator.properties[length - 1] === 'object' || this.newIndicator.properties[length - 1] === ')')
      ) {
        this.newIndicator.properties.push(operator);
      }
    } else {
      if (length !== 0 && this.newIndicator.properties[length - 1] !== '(') {
        if (typeof this.newIndicator.properties[length - 1] !== 'object' && this.newIndicator.properties[length - 1] !== ')') {
          this.newIndicator.properties.pop();
        }
        this.newIndicator.properties.push(operator);
      }
    }
  }
}

export class IndicatorList implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {};
  controller = ['$i18next', 'toastDeprecatedService', 'wallboardService', IndicatorListCtrl];
}

export default 'wallboardIndicatorList';
